import { Form } from 'antd'
import { ButtonCommon, InputCommon, ModalCommon, RequireTag, SelectCommon } from '../../../components'
import styles from './index.module.scss'
import { openNotificationWithIcon, useGetAllContracts } from '../../../hooks'
import { usePostMeterType, usePutMeterType } from '../../../hooks/query/meter'
import { IMeterType } from '../../../models'
import { useTranslation } from 'react-i18next'
import { LanguageEnum } from '../../../until'
interface IProps {
  visible: boolean
  onOk: () => void
  onCancel: () => void
  meterType?: IMeterType
}

export const MeterTypeModal = ({ visible, onOk, onCancel, meterType }: IProps) => {
  const [form] = Form.useForm()
  const { mutateAsync, isLoading } = usePostMeterType()
  const { mutateAsync: mutatePutAsync, isLoading: isLoadingPut} = usePutMeterType()
  const { data } = useGetAllContracts()
  const { t, i18n } = useTranslation()
  const handleFinish = async (values: any) => {
    try {
      meterType ? await mutatePutAsync({...meterType, subject_code: values.subject_code}) : await mutateAsync(values)
      openNotificationWithIcon('success', '', meterType ? t('staff.message.updateSuccess') : t('staff.message.createSuccess'))
      onOk()
    } catch (error: any) {
      openNotificationWithIcon('error', '', error?.message)
    }
  }

  const typeMeter: { label: string; value: number }[] = [
    { label: t('meter.water'), value: 1 },
    { label: t('meter.electric'), value: 2 },
    { label: t('meter.gas'), value: 3 },
  ]

  return (
    <ModalCommon
      destroyOnClose={true}
      title={meterType ? t('meter.editMeterType') : t('meter.addMeterType')}
      visible={visible}
      width="29%"
      className={styles.modal}
      onOk={onOk}
      onCancel={onCancel}
    >
      <Form form={form} onFinish={handleFinish} className={styles.form} layout="vertical">
        <div className={styles.form__wrap}>
          <Form.Item
            validateTrigger="onSubmit"
            label={
              <>
                {t('manager.IDcontract')}
                {!meterType && <RequireTag />}
              </>
            }
            initialValue={meterType?.contract_code || null}
            name="contract_code"
            className={styles.form__item}
            rules={[
              {
                required: true,
                message: t('manager.message.selectContract'),
              },
            ]}
          >
            <SelectCommon 
              disabled={!!meterType}
              placeholder={t('manager.placeholderContract')} 
              showSearch={true}
              optionFilterProp='label'
              options={data && data.length > 0 && data.map((el: any) => {return {label: el.contract_code, value: el.contract_code}}) || []}
            />
          </Form.Item>
          <Form.Item
            validateTrigger="onSubmit"
            label={
              <>
                {t('meter.type')}
                {!meterType && <RequireTag />}
              </>
            }
            name="type"
            initialValue={Number(meterType?.type) || null}
            className={styles.form__item}
            rules={[
              {
                required: true,
                message: t('meter.message.meterTypeSelect'),
              },
            ]}
          >
            <SelectCommon 
              disabled={!!meterType}
              placeholder={t('meter.meterTypePlaceholder')}
              options={typeMeter}
            />
          </Form.Item>
          <Form.Item
            validateTrigger="onSubmit"
            label={
              <>
                {t('meter.subjectCode')}
                <RequireTag />
              </>
            }
            name="subject_code"
            initialValue={meterType?.subject_code || null}
            className={styles.form__item}
            rules={[
              {
                required: true,
                message: t('meter.message.subjecCodeRequired'),
              }
            ]}
          >
            <InputCommon 
              maxLength={10} 
              placeholder={t('profile.message.placeholderInput')} 
              onBlur={() => {
                form.setFieldValue('subject_code', form.getFieldValue('subject_code')?.trim())
              }}
            />
          </Form.Item>
        </div>
        <div className={styles.form__btn__wrap}>
          <ButtonCommon type="ghost" onClick={onCancel}>
            {t('profile.cancel')}
          </ButtonCommon>
          <ButtonCommon style={{letterSpacing:  i18n.language === LanguageEnum.JAPANESE ? '-2px' : '0px' }} loading={isLoading || isLoadingPut} type="primary" htmlType="submit">
            {t('manager.save')}
          </ButtonCommon>
        </div>
      </Form>
    </ModalCommon>
  )
}
